






















































































































































import DictMixin from '@/mixins/dict-mixin';
import RoleServices from '@/services/role';
import { RuleActionDto } from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch, Prop } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class RuleActionItem extends mixins(DictMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @PropSync('item') syncItem!: RuleActionDto;
  @Prop() entity!: any;

  roleSrv = new RoleServices();

  formData: any = {};
  title = '添加动作';
  @Watch('visible')
  async onVisibleChange() {
    if (this.syncItem.actionCondition) {
      this.title = '编辑动作';
    } else {
      this.title = '添加动作';
    }
    this.formData = this.syncItem;
    this.formData.actionType = '0';
    // this.formData.alertFlag = this.formData.alertFlag ?? 0;
    if (this.formData.alertHandlerType == '1') {
      let uid = this.formData.alertHandler;
      let list = await this.roleSrv.getRoleUserList({ userId_eq: uid });
      let uname = list[0]?.userName || '';
      this.handlerUser = `${uid}/${uname}`;
    }
    if (this.formData.alertReviewerType == '1') {
      let uid = this.formData.alertReviewer;
      let list = await this.roleSrv.getRoleUserList({ userId_eq: uid });
      let uname = list[0]?.userName || '';
      this.reviewerUser = `${uid}/${uname}`;
    }
  }

  @Watch('formData', { deep: true })
  onFormDataChange() {
    this.$set(this.formData, 'alertHandler', this.formData.alertHandler);
    this.$set(this.formData, 'alertReviewer', this.formData.alertReviewer);
    this.$set(this.formData, 'alertHandleDue0', this.formData.alertHandleDue0);
    this.$set(this.formData, 'alertHandleDue1', this.formData.alertHandleDue1);
    this.$set(this.formData, 'alertHandleDue2', this.formData.alertHandleDue2);
    this.$set(this.formData, 'alertHandleDue3', this.formData.alertHandleDue3);
    this.$set(this.formData, 'alertReviewDue0', this.formData.alertReviewDue0);
    this.$set(this.formData, 'alertReviewDue1', this.formData.alertReviewDue1);
    this.$set(this.formData, 'alertReviewDue2', this.formData.alertReviewDue2);
    this.$set(this.formData, 'alertReviewDue3', this.formData.alertReviewDue3);
    this.$set(this.formData, 'alertFlag', this.formData.alertFlag);
  }

  changeAlertLevel(e: string) {
    let handleDue: any, reviewDue: any;
    if (e == '1') {
      handleDue = this.DICT_ALERT_LEVEL1_HANDLE_DUE;
      reviewDue = this.DICT_ALERT_LEVEL1_REVIEW_DUE;
    } else if (e == '2') {
      handleDue = this.DICT_ALERT_LEVEL2_HANDLE_DUE;
      reviewDue = this.DICT_ALERT_LEVEL2_REVIEW_DUE;
    } else {
      handleDue = this.DICT_ALERT_LEVEL3_HANDLE_DUE;
      reviewDue = this.DICT_ALERT_LEVEL3_REVIEW_DUE;
    }
    this.formData.alertHandleDue0 = handleDue[0]?.value || 1;
    this.formData.alertHandleDue1 = handleDue[1]?.value || 1;
    this.formData.alertHandleDue2 = handleDue[2]?.value || 1;
    this.formData.alertHandleDue3 = handleDue[3]?.value || 1;
    this.formData.alertReviewDue0 = reviewDue[0]?.value || 1;
    this.formData.alertReviewDue1 = reviewDue[1]?.value || 1;
    this.formData.alertReviewDue2 = reviewDue[2]?.value || 1;
    this.formData.alertReviewDue3 = reviewDue[3]?.value || 1;
  }

  handlerUser: string = '';
  selectHandlerUser(user: { userId: string; userName: string }) {
    this.formData.alertHandler = user.userId;
  }

  reviewerUser: string = '';
  selectReviewerUser(user: { userId: string; userName: string }) {
    this.formData.alertReviewer = user.userId;
  }

  confirm() {
    if (this.isFormEmpty()) {
      this.$message.error('请将信息填写完整');
      return false;
    }
    this.$emit('success', this.formData);
    this.syncVisible = false;
  }

  isFormEmpty() {
    let keys = ['actionType', 'actionName', 'alertLevel', 'alertMessage', 'alertHandler', 'alertReviewer'];
    let isEmpty = false;
    keys.forEach((v: string) => {
      if (!this.formData[v]) isEmpty = true;
    });
    return isEmpty;
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
